import { render, staticRenderFns } from "./Person.1.vue?vue&type=template&id=febb2fdc&"
import script from "./Person.1.vue?vue&type=script&lang=js&"
export * from "./Person.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports